import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-lg-column w-100" }
const _hoisted_2 = { class: "d-inline-flex gap-3" }
const _hoisted_3 = { class: "d-inline-flex gap-3" }
const _hoisted_4 = { class: "d-inline-flex gap-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-50" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FormField, {
        required: true,
        name: "first_name",
        containerClass: "flex-fill w-50",
        label: "First Name",
        placeholder: "First Name",
        type: "text"
      }),
      _createVNode(_component_FormField, {
        required: true,
        name: "last_name",
        containerClass: "flex-fill w-50",
        label: "Surname",
        placeholder: "Surname",
        type: "text"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_FormField, {
        required: true,
        name: "date_of_birth",
        containerClass: "flex-fill w-50",
        label: "Date of Birth",
        placeholder: "Pick a date",
        dateFormat: _ctx.dateFormat,
        disabledDates: _ctx.disableFutureDates,
        type: "datepicker"
      }, null, 8, ["dateFormat", "disabledDates"]),
      _createVNode(_component_FormField, {
        required: true,
        disabled: true,
        name: "email",
        containerClass: "flex-fill w-50",
        label: "Email",
        placeholder: "Email",
        type: "email",
        onInput: _ctx.handleEmailInput
      }, null, 8, ["onInput"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_FormField, {
        required: true,
        name: "mobile_number",
        containerClass: "flex-fill w-50",
        label: "Mobile Number",
        placeholder: "Mobile Number",
        type: "text",
        mask: _ctx.maskingMobile
      }, null, 8, ["mask"]),
      _hoisted_5
    ])
  ]))
}